// src/actions/hdfcCardActions.js
import axios from "axios";
import {
  GET_ALL_HDFC_CARD_REQUEST,
  GET_ALL_HDFC_CARD_SUCCESS,
  GET_ALL_HDFC_CARD_FAIL,
  CREATE_HDFC_CARD_REQUEST,
  CREATE_HDFC_CARD_SUCCESS,
  CREATE_HDFC_CARD_FAIL,
  UPDATE_HDFC_CARD_REQUEST,
  UPDATE_HDFC_CARD_SUCCESS,
  UPDATE_HDFC_CARD_FAIL,
  DELETE_HDFC_CARD_REQUEST,
  DELETE_HDFC_CARD_SUCCESS,
  DELETE_HDFC_CARD_FAIL,
  BULK_DELETE_HDFC_CARD_REQUEST,
  BULK_DELETE_HDFC_CARD_SUCCESS,
  BULK_DELETE_HDFC_CARD_FAIL,
  IMPORT_HDFC_CARD_REQUEST,
  IMPORT_HDFC_CARD_SUCCESS,
  IMPORT_HDFC_CARD_FAIL,
  EXPORT_HDFC_CARD_REQUEST,
  EXPORT_HDFC_CARD_SUCCESS,
  EXPORT_HDFC_CARD_FAIL,
  GET_HDFC_CARD_DEPARTMENTS_REQUEST,
  GET_HDFC_CARD_DEPARTMENTS_SUCCESS,
  GET_HDFC_CARD_DEPARTMENTS_FAIL,
} from "../constants/hdfccardConstants";
import { logout } from "./userActions";

const baseUrl = process.env.REACT_APP_API_URL;

// Get HDFC Card records with pagination and search
export const getHdfcCardRecords =
  (queryParams = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_ALL_HDFC_CARD_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.get(
        `${baseUrl}/hdfccard${queryParams ? `?${queryParams}` : ""}`,
        config,
      );

      dispatch({
        type: GET_ALL_HDFC_CARD_SUCCESS,
        payload: data,
      });
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch(logout());
        return;
      }
      dispatch({
        type: GET_ALL_HDFC_CARD_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Get HDFC Card Departments
export const getHdfcCardDepartments = () => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_HDFC_CARD_DEPARTMENTS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`${baseUrl}/hdfccard/departments`, config);

    dispatch({
      type: GET_HDFC_CARD_DEPARTMENTS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: GET_HDFC_CARD_DEPARTMENTS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Create new HDFC Card record
export const createHdfcCardRecord =
  (recordData) => async (dispatch, getState) => {
    try {
      dispatch({ type: CREATE_HDFC_CARD_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.post(
        `${baseUrl}/hdfccard`,
        recordData,
        config,
      );

      dispatch({
        type: CREATE_HDFC_CARD_SUCCESS,
        payload: data,
      });
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch(logout());
        return;
      }
      dispatch({
        type: CREATE_HDFC_CARD_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Update HDFC Card record
export const updateHdfcCardRecord =
  (id, recordData) => async (dispatch, getState) => {
    try {
      dispatch({ type: UPDATE_HDFC_CARD_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.put(
        `${baseUrl}/hdfccard/${id}`,
        recordData,
        config,
      );

      dispatch({
        type: UPDATE_HDFC_CARD_SUCCESS,
        payload: data,
      });
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch(logout());
        return;
      }
      dispatch({
        type: UPDATE_HDFC_CARD_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Delete HDFC Card record
export const deleteHdfcCardRecord = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: DELETE_HDFC_CARD_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.delete(`${baseUrl}/hdfccard/${id}`, config);

    dispatch({
      type: DELETE_HDFC_CARD_SUCCESS,
      payload: id,
    });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: DELETE_HDFC_CARD_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Bulk delete HDFC Card records
export const bulkDeleteHdfcCardRecords =
  (ids) => async (dispatch, getState) => {
    try {
      dispatch({ type: BULK_DELETE_HDFC_CARD_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.post(
        `${baseUrl}/hdfccard/bulk-delete`,
        { ids },
        config,
      );

      dispatch({
        type: BULK_DELETE_HDFC_CARD_SUCCESS,
        payload: { deletedCount: data.deletedCount },
      });
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch(logout());
        return;
      }
      dispatch({
        type: BULK_DELETE_HDFC_CARD_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Import HDFC Card records from file
export const importHdfcCardRecords =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({ type: IMPORT_HDFC_CARD_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.post(
        `${baseUrl}/hdfccard/import`,
        formData,
        config,
      );

      dispatch({
        type: IMPORT_HDFC_CARD_SUCCESS,
        payload: data,
      });
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch(logout());
        return;
      }
      dispatch({
        type: IMPORT_HDFC_CARD_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Export HDFC Card records to file
export const exportHdfcCardRecords = () => async (dispatch, getState) => {
  try {
    dispatch({ type: EXPORT_HDFC_CARD_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
      responseType: "blob",
    };

    const { data } = await axios.get(`${baseUrl}/hdfccard/export`, config);

    // Create download link
    const url = URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "HdfcCard_Export.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);

    dispatch({
      type: EXPORT_HDFC_CARD_SUCCESS,
      payload: "Export completed successfully",
    });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: EXPORT_HDFC_CARD_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const syncHdfcCardTaskStatus = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: "SYNC_HDFC_CARD_TASK_STATUS_REQUEST",
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo?.token}`,
      },
    };

    const { data } = await axios.post(
      `${baseUrl}/hdfccard/sync-status`,
      {},
      config,
    );

    dispatch({
      type: "SYNC_HDFC_CARD_TASK_STATUS_SUCCESS",
      payload: data,
    });

    return data; // Return data including updatedRecords
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: "SYNC_HDFC_CARD_TASK_STATUS_FAIL",
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    throw error;
  }
};

// Add this function at the end of your HdfcCardAction.js file
export const getFieldExecutives =
  (search = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: "GET_FIELD_EXECUTIVES_REQUEST",
      });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo?.token}`,
        },
      };

      const { data } = await axios.get(
        `${baseUrl}/hdfccard/field-executives?search=${encodeURIComponent(search)}`,
        config,
      );

      dispatch({
        type: "GET_FIELD_EXECUTIVES_SUCCESS",
        payload: data,
      });

      return data; // Return the data
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch(logout());
        return;
      }
      dispatch({
        type: "GET_FIELD_EXECUTIVES_FAIL",
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
      throw error; // Throw error so it can be caught
    }
  };
